// Calculate sequence animation index from maximum available by position
export const getPositionIndex = (position: number, max: number) =>
  Math.max(0, Math.min(Math.floor(position * max - 1), max));

// Calculate opacity percentage from animation sequence position.
export const getOpacity = (position: number, speed = 0) => {
  const multiplier = speed / 100;
  const opacity = position < multiplier ? 1 - position / multiplier : 0;

  return opacity;
};
